var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-approval-orders-table"},[_vm._l((_vm.orders),function(order,index){return _c('my-orders-table-item',{key:index,attrs:{"order-require-approval":"","order":order}})}),(!_vm.orders.length)?_c('orders-table-empty',[_vm._v(" No orders waiting your approval ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }